<template>
    <div class="all">
        <div class="body">
            <img :src="kaifazhong">
            <p>开发中,敬请期待</p>
        </div>
    </div>
</template>

<script>
    import kaifazhong from '@/assets/images/kaifazhong.png'

    export default {
        data() {
            return {
                kaifazhong: kaifazhong,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #fff;
    }

    .body {
        margin: 35% 0;
        text-align: center;
        p {
            text-align: center;
        }
        img {
            top: 10%;
            left: 2%;
            position: relative;
        }

    }
</style>